export const PIPELINE_SPECIALIZATIONS = [
  'CG',
  'Comp',
  'Mattepainting',
  'SIM',
  'FX',
  'Lighting',
  'Rigging',
  'Animation',
  'Clean-up',
  'Roto',
  'Prep',
  'Tracking',
  'Paint',
  'Layout',
  'Matchmove',
  'Supervising',
  'Team Lead',
] as const;

export type PipelineSpecialization = (typeof PIPELINE_SPECIALIZATIONS)[number];

export const VIRTUAL_ROLE_OPTIONS = [
  { id: 'virtual-junior', labelKey: 'bidding.levelJunior' as const },
  { id: 'virtual-mid', labelKey: 'bidding.levelMid' as const },
  { id: 'virtual-senior', labelKey: 'bidding.levelSenior' as const },
  { id: 'virtual-lead', labelKey: 'bidding.levelLead' as const },
] as const;
